export default __webpack_public_path__ + "static/media/logo_jalisco_lo_hacemos.2ebf9880.png";